module.exports = __webpack_public_path__ + "img/sq-bg2.7c62176c.png";